module.exports = __webpack_public_path__ + "static/media/US.936feee6.svg";